import { render } from "./App.vue?vue&type=template&id=cfd4699a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=cfd4699a&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__